export default (): 'en-US' => 'en-US';
